<script setup lang="ts">
import ProjectTabSkeleton from '~/components/property/ProjectTabSkeleton.vue';
</script>

<template>
  <div
    class="mx-auto max-w-[1320px] px-4 pb-20 pt-5 tablet:px-8"
    aria-busy="true"
    data-testid="project-page-skeleton"
  >
    <div class="mb-3 h-4 w-40 animate-pulse rounded bg-black-05" />
    <div class="mb-2 h-8 w-2/3 animate-pulse rounded bg-black-05 desktop:w-1/3" />
    <div class="mb-5 h-4 w-1/2 animate-pulse rounded bg-black-05 desktop:w-1/4" />
    <div class="mb-6 h-[260px] animate-pulse rounded-2xl bg-black-05 desktop:h-[420px]" />
    <div class="grid grid-cols-1 gap-6 desktop:grid-cols-[2fr_1fr]">
      <div class="flex flex-col gap-4">
        <div class="h-11 animate-pulse rounded-xl bg-black-05" />
        <ProjectTabSkeleton />
      </div>
      <div class="flex flex-col gap-4">
        <div class="h-[220px] animate-pulse rounded-2xl bg-black-05" />
        <div class="h-[180px] animate-pulse rounded-2xl bg-black-05" />
      </div>
    </div>
  </div>
</template>
